<script lang="ts" setup>
import {UserInfo} from "@/common/utils/auth";
import SentryContext from "~components/util/SentryContext.vue"
import HomeNavBar, {MenuEntry} from "~components/home/HomeNavBar.vue";
import {computed} from "vue";

const props = withDefaults(
  defineProps<{
    menu?: MenuEntry[]
    sentryContext: Record<string, unknown>
    user: UserInfo | null
  }>(),
  {
    menu: undefined
  }
)

const DEFAULT_MENU = [
  {label: "How it Works", href: "/how-it-works"},
  {label: "Research", href: "/research"},
  {label: "Schools/Districts", href: "/district"},
  {label: "Online Tutoring", href: "/tutor"},
  {label: "Homeschool", href: "/homeschool"},
  {label: "Pricing", href: "/pricing"},
  {label: "Free Trial", href: "/sign-up"},
]

const homeMenu = computed(() => props.menu ?? DEFAULT_MENU)

// tutor menu:
//    Online Tutoring -> /tutor
//    Homeschool Program -> /homeschool,
//    Book a call -> https://lyrics2learn.user.com/landing/xp6s12/  (provided to page by config)

// homeschool menu:
//    Specialized Tutoring -> /tutor
//    Features -> #features
//    Pricing -> #pricing
//    How It Works ->  #how-it-works
//    Sign Up -> https://buy.stripe.com/7sI7vza6u5Fu4mI5lW  (FIXME: switch this to signup with homeschool pre-selected)

</script>

<template>
  <div class="inertia-page">
    <header
      id="header"
      class="navbar bg-primary navbar-expand-lg navbar-end navbar-absolute-top navbar-dark navbar-show-hide fixed-top top-0"
    >
      <HomeNavBar :menu="homeMenu"/>
    </header>
    <SentryContext :context="sentryContext"/>
    <slot/>
  </div>
</template>
